export enum LayoutConfigType {
    GridActionRow = 0,
    Grid = 1,
    Form = 2,
    Filter = 3
}